import Vue from 'vue'
import App from './App.vue'

if ( !document.oldBrowser ) {
	Vue.config.productionTip = false

	new Vue( {
		render: h => h( App ),
	} ).$mount( '#app' )
}
